import { render, staticRenderFns } from "./NewImmunizationBroadcast.vue?vue&type=template&id=0c8a118a&"
import script from "./NewImmunizationBroadcast.vue?vue&type=script&lang=js&"
export * from "./NewImmunizationBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./NewImmunizationBroadcast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports